import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';
import styles from './index.css';

const ExclusiveVideo = ({ content = [] }) => {
    const [playIndex, setPlayIndex] = useState(0);

    return content.length ? (
        <div className={styles.wrap}>
            <div className={styles.left}>
                <Player
                    key={playIndex}
                    videoConfig={{
                        title: content[playIndex].title,
                        posterUrl: content[playIndex].posterUrl,
                        videoPlayUrl: content[playIndex].videoPlayUrl,
                    }}
                    playermsg={{
                        // 播放器宽
                        width: 580,
                        // 播放器高
                        height: 457,
                        // 是否自动播放
                        autoPlay: false,
                        // 是否显示播放控件
                        controls: true,
                    }}
                />
            </div>
            <div className={styles.right}>
                <div className={styles.playList}>
                    {content.map((item, index) => (
                        <div
                            key={index}
                            className={`${styles.playItem} ${index === playIndex ? styles.playItemActive : ''}`}
                            onClick={() => {
                                if (playIndex !== index) {
                                    setPlayIndex(index);
                                }
                            }}
                            title={item.title}>
                            {item.title}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ) : null;
};

ExclusiveVideo.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(ExclusiveVideo);
